import axios from 'axios';
import { GETREQUESTOPTIONS } from './apiService';

const API_URL = '/api/document-schemas';

export interface DocumentSchemaRecord {
    _id: string;
    ownerType: 'nordinsight' | 'department';
    department_id?: string;
    key: string;
    name: string;
    description?: string;
    schema: Record<string, any>;
    version: number;
    createdAt: string;
    updatedAt: string;
}

export const getDocumentSchema = async (
    key: string,
    version?: number
): Promise<any> => {
    const params = new URLSearchParams();
    if (version !== undefined) {
        params.set('version', String(version));
    }

    const url = params.toString()
        ? `${API_URL}/${key}?${params.toString()}`
        : `${API_URL}/${key}`;

    const response = await axios.get(url, GETREQUESTOPTIONS());
    return response.data;
};

export const listDocumentSchemas = async (): Promise<DocumentSchemaRecord[]> => {
    const response = await axios.get(API_URL, GETREQUESTOPTIONS());
    return response.data;
};

export const updateDocumentSchema = async (
    id: string,
    payload: Partial<DocumentSchemaRecord>
): Promise<DocumentSchemaRecord> => {
    const response = await axios.put(
        `${API_URL}/${id}`,
        payload,
        GETREQUESTOPTIONS()
    );
    return response.data;
};

export const createDocumentSchema = async (
    payload: Omit<DocumentSchemaRecord, '_id' | 'createdAt' | 'updatedAt'>
): Promise<DocumentSchemaRecord> => {
    const response = await axios.post(API_URL, payload, GETREQUESTOPTIONS());
    return response.data;
};

export const getSchemaImpactCount = async (
    key: string,
    version: number
): Promise<number> => {
    const response = await axios.get(
        `${API_URL}/${key}/impact?version=${version}`,
        GETREQUESTOPTIONS()
    );
    return response.data.count;
};
